import isReturnExcludedItem from "../../util/isReturnExcludedItem.mjs";
const productPageGetters = {
  /* props used in ProductPage */
  productPageProps(state, getters) {
    return {
      addToCartStickyProps: getters.addToCartStickyProps,
      ariaLive: state.ariaLive,
      breadcrumbs: getters.computedBreadcrumbs,
      c9rProductDetail: (getters == null ? void 0 : getters.c9rProductDetail) || null,
      flairBadge: getters.computedFlairBadge,
      isPup: getters.isPup,
      modalContainer: state.modalContainer,
      pupNotice: getters.pupNoticeProps,
      rrRecsProps: getters.rrRecsProps,
      showPupNotice: getters.showPupNotice,
      showRecs: getters.showRecs,
      showAtcSticky: getters.showAtcSticky,
      showXlBreakpoint: getters.appPropsMap.launchToggles.enableXlBreakpoint
    };
  },
  showAtcSticky(state, getters) {
    const {
      membershipMessaging: {
        includeMembership
      },
      showMemberOnlyAddToCart,
      showNotifyMe
    } = getters;
    const {
      isPup
    } = state.product.displayOptions.pupInfo;
    const isJfmDisabled = !includeMembership && showMemberOnlyAddToCart;
    return !showNotifyMe && !isJfmDisabled && !state.modalIsOpen && !isPup;
  },
  addToCartStickyProps(state, getters) {
    var _a, _b, _c;
    const {
      sizeLabel,
      computedSelectedSize: size
    } = getters;
    const color = ((_b = (_a = getters.computedSelectedColor) == null ? void 0 : _a.displayLabel) == null ? void 0 : _b.toLowerCase()) === "none" ? "" : getters.computedSelectedColor.displayLabel;
    return {
      imageSrc: `${getters.computedMediaCenterImages[0].baseUri}?size=47.88x47.88`,
      brandName: state.product.brand.name,
      productTitle: state.product.title,
      color,
      colorLabel: state.product.displayOptions.colorLabel,
      size: ((_c = size == null ? void 0 : size.toLowerCase) == null ? void 0 : _c.call(size)) === "none" ? "" : size,
      sizeLabel,
      fulfillmentLabel: getters.atcStickyFulfillmentLabel,
      fulfillmentLocation: getters.atcStickyFulfillmentLocation,
      addToCartButtonProps: getters.computedAddToCartButtonProps,
      validationText: getters.atcStickyButtonValidationText
    };
  },
  atcStickyButtonValidationText(state, getters) {
    const {
      hasValidSize,
      hasValidColor,
      hasSelectedValidFulfillmentStickyATC
    } = getters;
    let text = "";
    if (!hasValidColor && !hasValidSize && !hasSelectedValidFulfillmentStickyATC) text = "Select options";
    if (hasValidColor && hasValidSize && !hasSelectedValidFulfillmentStickyATC) text = "Select shipping";
    if (hasValidColor && !hasValidSize && hasSelectedValidFulfillmentStickyATC) text = "Select size";
    if (!hasValidColor && hasValidSize && hasSelectedValidFulfillmentStickyATC) text = "Select color";
    if (hasValidColor && !hasValidSize && !hasSelectedValidFulfillmentStickyATC) text = "Select size & shipping";
    if (!hasValidColor && hasValidSize && !hasSelectedValidFulfillmentStickyATC) text = "Select color & shipping";
    if (!hasValidColor && !hasValidSize && hasSelectedValidFulfillmentStickyATC) text = "Select size & color";
    return text;
  },
  /**
   * @param {Array} state.product.breadcrumbs: list of breadcrumbs (name and url)
   * @param {String} state.product.styleId: selected style id
   * @returns {Array<object>} Returns an object if there is array of breadcrumbs
   */
  computedBreadcrumbs(state) {
    const {
      breadcrumbs,
      styleId
    } = state.product;
    return [...breadcrumbs, {
      item: {
        name: `#${styleId}`
      }
    }];
  },
  rrRecsProps(state, getters) {
    return {
      message: getters.rrMessage,
      recs: getters.rrRecs,
      recsComponent: state.richRelevance.component,
      shopAllCatText: getters.shopAllCatText,
      shopAllCatUrl: getters.shopAllCatUrl,
      showLoadingRecs: getters.showLoadingRecs
    };
  },
  /**
   * getters.computedSizeColorMessage
   *
   * @params from getters
   * @param {number} computedSelectedSku.price.price.value: currently selected price
   * @param {string} computedSelectedColor.name: Name of currently selected color
   * @param {string} getters.computedSelectedSize.label: Currently selected size label
   * @returns {String} message that contains selected color, size and price status
   */
  computedSizeColorMessage(state, getters) {
    const selectedPrice = getters.computedSelectedPriceValue;
    const selectedColor = getters.computedSelectedColor.name;
    const selectedSize = getters.computedSelectedSize;
    const colorAvailable = getters.selectedColorIsAvailable ? "" : ", color is sold out";
    const sizeAvailable = getters.selectedSizeIsAvailable ? "" : ", size is sold out";
    const priceMessage = selectedPrice ? `price set to ${selectedPrice}` : "no price selected";
    let colorMessage;
    let sizeMessage;
    if (selectedColor) colorMessage = selectedColor === "NONE" ? "" : `selected color set to ${selectedColor}${colorAvailable}, `;
    else colorMessage = "no color selected, ";
    if (selectedSize) sizeMessage = selectedSize === "NONE" ? "" : `selected size set to ${selectedSize}${sizeAvailable}, `;
    else sizeMessage = "no size selected, ";
    return `${colorMessage}${sizeMessage}${priceMessage}`;
  },
  /**
   * getters.showPupNotice
   * don't allow banners to be shown if pup is unlucky or data
   * isn't available
   * @param state
   * @returns {false|boolean}
   */
  showPupNotice(state) {
    const {
      pupInfo
    } = state.product.displayOptions;
    return (!!pupInfo.originPupBannerInfo || !!pupInfo.pupBannerInfo) && pupInfo.type !== "UNLUCKY";
  },
  /**
   * getter.pupNoticeProductTitle
   * return the correct banner cta title
   * if a pup page is displayed return the result for pap banner
   * if a pap page is displayed return the result for a pup banner
   * @param state
   * @returns {String}
   */
  pupNoticeProductTitle(state) {
    var _a, _b;
    const {
      pupInfo
    } = state.product.displayOptions;
    if (pupInfo.isPup) {
      return ((_a = pupInfo.pupBannerInfo) == null ? void 0 : _a.productTitle) ? `There's a newer version of ${pupInfo.pupBannerInfo.productTitle}` : "";
    }
    return ((_b = pupInfo.originPupBannerInfo) == null ? void 0 : _b.productTitle) ? `Below is the newest version of ${pupInfo.originPupBannerInfo.productTitle}` : "";
  },
  /**
   * getter.pupNoticeProductLink
   * return the correct banner cta link
   * if a pup page is displayed return the result for pap banner
   * if a pap page is displayed return the result for a pup banner
   * @param state
   * @returns {String}
   */
  pupNoticeProductLink(state) {
    var _a, _b;
    const {
      pupInfo
    } = state.product.displayOptions;
    if (pupInfo.isPup) {
      return (pupInfo == null ? void 0 : pupInfo.ctaHref) || "";
    }
    return ((_a = pupInfo.originPupBannerInfo) == null ? void 0 : _a.productLink) ? `${(_b = pupInfo == null ? void 0 : pupInfo.originPupBannerInfo) == null ? void 0 : _b.productLink}?redirect-pup=false` : "";
  },
  /**
   * getter.pupNoticeProductImage
   * return the correct banner image
   * if a pup page is displayed return the result for pap banner
   * if a pap page is displayed return the result for a pup banner
   * @param state
   * @returns {String}
   */
  pupNoticeProductImage(state) {
    var _a;
    const {
      pupInfo
    } = state.product.displayOptions;
    if (pupInfo.isPup) {
      const matches = (pupInfo == null ? void 0 : pupInfo.ctaHref.match(/(\d+)/)[0]) || null;
      return matches ? `/media/product/${matches}` : "";
    }
    return ((_a = pupInfo == null ? void 0 : pupInfo.originPupBannerInfo) == null ? void 0 : _a.productImage) || "";
  },
  /**
   * getter.pupNoticeProductMessage
   * return the correct banner message
   * if a pup page is displayed return the result for pap banner
   * if a pap page is displayed return the result for a pup banner
   * @param state
   * @returns {String}
   */
  pupNoticeProductMessage(state) {
    var _a;
    const {
      pupInfo
    } = state.product.displayOptions;
    if (pupInfo.isPup) {
      return (pupInfo == null ? void 0 : pupInfo.messageText) || "";
    }
    return ((_a = pupInfo == null ? void 0 : pupInfo.originPupBannerInfo) == null ? void 0 : _a.contentMessage) || "";
  },
  /**
   * getters.pupNoticeProps
   * return the correct banner props
   * banner has different attributes based on whether it's pup or pap
   * don't try to get any values if we don't want the pup notice shown
   * @param state
   * @param getters
   * @returns {object}
   */
  pupNoticeProps(state, getters) {
    if (getters.showPupNotice) {
      const {
        pupInfo
      } = state.product.displayOptions;
      return {
        productTitle: getters.pupNoticeProductTitle,
        productLink: getters.pupNoticeProductLink,
        productImage: getters.pupNoticeProductImage,
        labelText: (pupInfo == null ? void 0 : pupInfo.ctaText) || "Go to archived product page",
        contentMessage: getters.pupNoticeProductMessage
      };
    }
    return {};
  },
  shopAllCatText(state) {
    var _a, _b;
    return state.product.breadcrumbs.length ? `Shop All ${(_b = (_a = state.product.breadcrumbs[state.product.breadcrumbs.length - 1]) == null ? void 0 : _a.item) == null ? void 0 : _b.name}` : "";
  },
  shopAllCatUrl(state) {
    var _a, _b;
    return state.product.breadcrumbs.length ? (_b = (_a = state.product.breadcrumbs[state.product.breadcrumbs.length - 1]) == null ? void 0 : _a.item) == null ? void 0 : _b.url : "";
  },
  showPlaRecs(state, getters) {
    return !getters.showSimilarItems && getters.appPropsMap.triageToggles.plaRecs && getters.plaUrlParamExists;
  },
  showOrganicRecs(state, getters) {
    if (typeof window === "undefined") return false;
    const {
      document: doc,
      location: loc
    } = window;
    const {
      searchEngineList
    } = getters.appPropsMap.textStrings;
    const seTest = new RegExp(searchEngineList, "i");
    const isFromSearch = !!doc.referrer && !doc.referrer.includes(loc.hostname) && seTest.test(doc.referrer);
    return !getters.showPlaRecs && !getters.showSimilarItems && isFromSearch;
  },
  organicRecsLoaded(state) {
    var _a, _b;
    return !!((_b = (_a = state.richRelevance.placements.organicRecs) == null ? void 0 : _a.items) == null ? void 0 : _b.length);
  },
  showLoadingRecs(state, getters) {
    return !getters.rrRecsLoaded && getters.showRecs;
  },
  plaRecsLoaded(state) {
    var _a, _b;
    return !!((_b = (_a = state.richRelevance.placements.plaRecs) == null ? void 0 : _a.items) == null ? void 0 : _b.length);
  },
  plaUrlParamExists(state) {
    const {
      cm_mmc: plaParam
    } = state.urlSearchParams;
    return !!(plaParam && typeof plaParam === "string" && plaParam.includes("PLA"));
  },
  similarItemsLoaded(state) {
    var _a, _b;
    return !!((_b = (_a = state.richRelevance.placements.similarItems) == null ? void 0 : _a.items) == null ? void 0 : _b.length);
  },
  isPup(state) {
    var _a, _b;
    return !!((_b = (_a = state.product.displayOptions) == null ? void 0 : _a.pupInfo) == null ? void 0 : _b.isPup);
  },
  isNmwa(state) {
    return !!state.product.allDisplayableSkusAreBackorder;
  },
  showSimilarItems(state, getter) {
    return getter.isPup || getter.isNmwa;
  },
  rrRecsLoaded(state, getters) {
    return !!((getters.plaRecsLoaded || getters.similarItemsLoaded || getters.organicRecsLoaded) && state.richRelevance.component);
  },
  showRecs(state, getters) {
    return getters.showPlaRecs || getters.showSimilarItems || getters.showOrganicRecs;
  },
  rrRecs(state, getters) {
    if (getters.showPlaRecs) {
      return state.richRelevance.placements.plaRecs;
    }
    if (getters.showSimilarItems) {
      return state.richRelevance.placements.similarItems;
    }
    if (getters.showOrganicRecs) {
      return state.richRelevance.placements.organicRecs;
    }
    return {};
  },
  rrMessage(state, getters) {
    const defaultMsg = getters.appPropsMap.textStrings.plaRecommendationsMessage;
    if (getters.showPlaRecs) {
      return defaultMsg;
    }
    if (getters.showSimilarItems) {
      return getters.appPropsMap.textStrings.similarItemsMessage;
    }
    if (getters.showOrganicRecs) {
      return defaultMsg;
    }
    return "";
  },
  /**
   * getters.computedEstimatedReward
   * @param {Number} state.product.displayOptions.estimatedReward:
   * @param {Number} state.quantity: quantity to add to cart
   * @returns {Array<Object>} formatted Reward object containing
   * bonusCardValue, productEstimatedReward, and totalEstimatedReward
   */
  computedEstimatedReward(state) {
    const {
      estimatedReward = null
    } = state.product.displayOptions;
    const {
      quantity
    } = state;
    const bonusCardValue = 30;
    const productEstimatedReward = parseInt(estimatedReward * quantity, 10);
    const totalEstimatedReward = parseInt(productEstimatedReward + bonusCardValue, 10);
    return {
      bonusCardValue: bonusCardValue.toString(),
      productEstimatedReward: productEstimatedReward.toString(),
      totalEstimatedReward: totalEstimatedReward.toString()
    };
  },
  /**
   * getters.shouldShowBillboardsMixedPrice
   *
   * @param {boolean} getters.priceInfo.showPercentOffSavings
   * @param {boolean} state.product.displayOptions.showDividendMessage
   * @param {boolean} state.product.mixedPriceOptions.isMixedPrice
   * @param {boolean} getters.appPropsMap.mabcEarnPeriodToggle
   * @returns {boolean}
   */
  shouldShowBillboardsMixedPrice(state, getters) {
    var _a;
    return !getters.priceInfo.showPercentOffSavings && !state.product.displayOptions.showDividendMessage && ((_a = state.product.mixedPriceOptions) == null ? void 0 : _a.isMixedPrice) && getters.appPropsMap.mabcEarnPeriodToggle;
  },
  /**
   * getters.newMemberOfferDetailsModalProps
   *
   * @param {string} getters.appPropsMap.textStrings.membershipTooFarEarnDates
   * @returns {Object} earnDates string information for membership banner modal
   */
  newMemberOfferDetailsModalProps(state, getters) {
    var _a, _b;
    return {
      earnDates: ((_b = (_a = getters.appPropsMap) == null ? void 0 : _a.textStrings) == null ? void 0 : _b.membershipTooFarEarnDates) || ""
    };
  },
  /**
   * getters.isRewards5to30Item
   *
   * @param {boolean} state.product.displayOptions.showDividendMessage
   *                  flag that, when true, indicates that the item is full-price
   * @param {number} getters.computedPrice.minPrice.value
   *                 the price selected for this product
   * @returns {boolean}
   */
  isRewards5to30Item(state, getters) {
    return (state.product.displayOptions.showDividendMessage || getters.shouldShowBillboardsMixedPrice) && getters.computedPrice.minPrice.value >= 50 && getters.computedPrice.minPrice.value < 300;
  },
  /**
   * getters.isRewardsGte30Item
   *
   * @param {boolean} state.product.displayOptions.showDividendMessage
   *                  flag that, when true, indicates that the item is full-price
   * @param {number} getters.computedPrice.minPrice.value
   *                 the price selected for this product
   * @returns {boolean}
   */
  isRewardsGte30Item(state, getters) {
    return !!((state.product.displayOptions.showDividendMessage || getters.shouldShowBillboardsMixedPrice) && getters.computedPrice.minPrice.value >= 300);
  },
  /**
   * getters.showAcquisitionBillboard
   *
   * @param {boolean} getters.appPropsMap.mabcEarnPeriodToggle.enabled:
   *                  must be MABC period to show 50-to-300 Acquisition Billboard
   * @param {boolean} getters.appPropsMap.triageToggles.allowAcquisitionBillboard: feature toggle
   * @param {boolean} state.unifiedCustomerData.isMember: joint user membership status
   * @param {boolean} getters.isRewards5to30Item: is full price item && minPrice >= $50, < $300
   * @param {boolean} getters.isRewardsGte30Item: is full price item && minPrice >= $300
   * @param {boolean} state.product.displayOptions.pupInfo.isPup: is not a PUP page
   * @returns {boolean}
   */
  showAcquisitionBillboard(state, getters) {
    var _a, _b, _c;
    if (!((_a = getters.appPropsMap.mabcEarnPeriodToggle) == null ? void 0 : _a.enabled) || !((_b = getters.appPropsMap.triageToggles) == null ? void 0 : _b.allowAcquisitionBillboard)) {
      return false;
    }
    return !!(!((_c = getters.unifiedCustomerData) == null ? void 0 : _c.isMember) && (getters.isRewards5to30Item || getters.isRewardsGte30Item) && !state.product.displayOptions.pupInfo.isPup);
  },
  /**
   * getters.showRetentionBillboard
   *
   * @param {boolean} state.unifiedCustomerData.isMember: joint user membership status
   * @param {boolean} getters.appPropsMap.triageToggles.allowRetentionBillboard: feature toggle
   * @param {boolean} state.product.primaryCategory.name: product category name
   * @param {boolean} state.product.displayOptions.estimatedReward: full-price item gte $20
   * @param {number} state.product.stylePrice.minPrice.value:
   * the minimum price for any variant of this product
   * @param {number} getters.shouldShowBillboardsMixedPrice:
   * flag to show this component in mixed price PDP
   * @returns {boolean}
   */
  showRetentionBillboard(state, getters) {
    var _a, _b, _c;
    return !!(((_a = getters.unifiedCustomerData) == null ? void 0 : _a.isMember) && ((_b = getters.appPropsMap.triageToggles) == null ? void 0 : _b.allowRetentionBillboard) && !isReturnExcludedItem((_c = state.product.primaryCategory) == null ? void 0 : _c.name) && (state.product.displayOptions.showDividendMessage || getters.shouldShowBillboardsMixedPrice) && state.product.displayOptions.estimatedReward >= 2);
  }
};
export {
  productPageGetters as default
};
//# sourceMappingURL=productPageGetters.mjs.map
